module.exports = __webpack_public_path__ + "img/download.bdb8f3f3.svg";